import styled from 'styled-components';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';

const CartIcon = styled(ShoppingBasketIcon)`
  color: black;
  margin: 0 10px;
  vertical-align: middle;
  &:hover{
    opacity: 0.6;
  }
`;

export default CartIcon;
